import { render } from "./app-header.vue?vue&type=template&id=2c5a184a&scoped=true&ts=true"
import script from "./app-header.vue?vue&type=script&lang=ts"
export * from "./app-header.vue?vue&type=script&lang=ts"

import "./app-header.vue?vue&type=style&index=0&id=2c5a184a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c5a184a"]])

export default __exports__